import {HttpClient} from '@angular/common/http';
import {ToastService} from '../../toast-service';
import {Customer} from "../../../model/customer/customer";
import {Injectable} from "@angular/core";
import {CrystalclearCustomerBackUrl} from "../../config/crystalclear-customer-back-url";
import {BatchUpdateRequest} from "../../../model/api/batch-update-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../model/api/api-validation";
import {CommonCrudService} from "../../common/common-crud.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerCustomerService extends CommonCrudService<Customer> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_CUSTOMER_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_CUSTOMER,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_CUSTOMER);
  }

  public saveBatch(request: BatchUpdateRequest<Customer>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearCustomerBackUrl.SAVE_BATCH_CUSTOMER_CUSTOMER, request);
  }

  public cloneBatch(request: BatchUpdateRequest<Customer>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearCustomerBackUrl.CLONE_BATCH_CUSTOMER_CUSTOMER, request);
  }

}
